import React, { useCallback, useEffect, useState } from 'react';
import * as Styles from './styles';
import currencyFilter from 'utils/currency-filter';
import ConditionalFragment from 'components/conditional-fragment';
import { Trans, useTranslation } from 'react-i18next';
import VmPaymentForm from 'pages/member/new-vm/new-vm-step-7/vm-payment-form';
import { Formik } from 'formik';
import { initialValues, validate, cardError } from '../constants';
import Checkbox from 'components/common/radio-button';
import { validationObject } from 'validations';
import { Link } from 'react-router-dom';
import { isChargeCard } from '../utils';
import { H6, P } from 'components/reusable-css';
import { UpperCaseWord } from 'assets/css/common-styles';
import HeadingWithIcon from 'components/Heading/Heading';
import SlidingPanels from 'components/common/sliding-panel/SlidingPanel';
import { useMediaQuery } from '@mui/material';
import SlidingPanelPaymentTerm from 'components/billing/SlidingPanelPaymentTerm';
import { Icon } from 'semantic-ui-react';
import { mockBillingInfo, mockUserAccountDetails, mockUserUiDetails, mockVsInstance } from 'pages/mockup/constant';

const ServicesByServerpoint = ({ modalActive, handleCloseModal }) => {
  const match = useMediaQuery('(max-width:550px)');
  const [isOpen, setIsOpen] = useState(false);
  const rights = mockUserAccountDetails.user_rights;
  const userAccount = mockUserAccountDetails;
  const { t } = useTranslation();
  const account_approved = mockUserAccountDetails.account_approved || {};
  const {
    billing_due_bm_services,
    billing_bm_how_much_due,
    billing_bm_monthly_cost,
    billing_due_vps_services,
    billing_vps_how_many_due,
    billing_vps_active,
    billing_vps_monthly_cost,
    billing_vps_how_much_due,
    billing_vps_yearly_cost,
  } = mockBillingInfo || {};
  const [isChecked, setIsChecked] = useState(billing_due_bm_services === '1' ? 'bm_due_amount' : 'bm_funds_monthly');
  const [isCheckedVs, setIsCheckedVs] = useState(
    billing_due_vps_services == 1 ? 'billing_vps_how_much_due' : 'billing_vps_monthly_cost',
  );
  const credit_card_info = mockBillingInfo;
  const handlePayPalBilling = async () => {};
  const handleOneTimeBilling = async () => {};
  const handleBmPayment = async () => {};
  const escFunction = useCallback((event) => {
    if (event.key === 'Escape') {
      setIsOpen(false);
    }
  }, []);

  useEffect(() => {
    document.addEventListener('keydown', escFunction, false);
    return () => {
      document.removeEventListener('keydown', escFunction, false);
    };
  }, []);

  const vsInstanceArr = mockVsInstance?.vs_instance?.filter(
    (val) => val?.billing_schedule != 'hourly' && val?.vs_cancelation_scheduled != 1,
  );

  return (
    <Styles.CloudSC background={mockUserUiDetails.show_funds_deposit_section != 0}>
      <HeadingWithIcon name={'account/billing_info.string41'}>
        <P className="mt-3">{t('account/billing_info.string42')}</P>
        <div style={{ marginLeft: '-1.2em' }}>
          <Styles.CloudService>
            <HeadingWithIcon
              sub_heading
              name={
                mockBillingInfo?.billing_due_vs_services == 1
                  ? 'account/billing_info.string11'
                  : 'account/billing_info.string10'
              }
            >
              <Styles.Paragraph>
                <ConditionalFragment condition={account_approved == 1}>
                  <P>
                    {Number(mockBillingInfo?.billing_vs_active) > 0 ? (
                      <Trans
                        i18nKey={'account/billing_info.string12'}
                        components={{
                          span: <span style={{ fontWeight: 'bold' }} />,
                        }}
                        values={{
                          vs_count: mockBillingInfo?.billing_vs_active,
                          monthly_price: currencyFilter(
                            mockBillingInfo.billing_vs_monthly_cost,
                            mockUserAccountDetails?.account_currency,
                          ),
                          hourly_price: currencyFilter(
                            mockBillingInfo?.billing_vs_hourly_cost,
                            mockBillingInfo?.account_currency,
                            '',
                            true,
                          ),
                        }}
                      />
                    ) : (
                      t('account/billing_info.string13')
                    )}
                  </P>
                </ConditionalFragment>

                {Number(mockBillingInfo?.billing_vs_due_by_hours) > 0 ? (
                  <P style={{ color: 'red' }}>
                    <Trans
                      i18nKey={'account/billing_info.string16'}
                      components={{
                        bold_font: <span style={{ fontWeight: 'bold' }} />,
                        black_font: <span style={{ color: 'black' }} />,
                      }}
                      values={{
                        hours: mockBillingInfo?.billing_vs_due_by_hours,
                        price: currencyFilter(
                          `-${mockBillingInfo?.billing_vs_due_negative_balance}`,
                          mockBillingInfo?.account_currency,
                        ),
                      }}
                    />
                  </P>
                ) : (
                  <>
                    {Number(mockBillingInfo?.billing_vs_active) > 0 && (
                      <Styles.HighlightPara>
                        <Trans
                          i18nKey={'account/billing_info.string14'}
                          components={{
                            bold_font: <span style={{ fontWeight: 'bold' }} />,
                            black_font: <span style={{ color: 'black' }} />,
                          }}
                          values={{
                            days: mockBillingInfo?.billing_vs_days_left,
                          }}
                        />
                      </Styles.HighlightPara>
                    )}
                  </>
                )}
                {Number(mockBillingInfo?.billing_vs_due_full_balance) > 0 && (
                  <P>
                    <Trans
                      i18nKey={'account/billing_info.string17'}
                      components={{
                        bold_font: <span style={{ fontWeight: 'bold' }} />,
                      }}
                      values={{
                        price: currencyFilter(
                          mockBillingInfo?.billing_vs_due_full_balance,
                          mockBillingInfo?.account_currency,
                        ),
                      }}
                    />
                  </P>
                )}
              </Styles.Paragraph>
            </HeadingWithIcon>
          </Styles.CloudService>
          {mockUserUiDetails?.show_billing_reserved_instance == 1 && (
            <Styles.VsService
              id="add_funds_vs_reserved"
              isDue={billing_due_vps_services == 1}
              isActive={Number(billing_vps_active) > 0}
            >
              {modalActive && (
                <div
                  style={{ position: 'relative', right: 20, zIndex: 1000, fontSize: 30, cursor: 'pointer' }}
                  onClick={() => handleCloseModal()}
                >
                  <Icon name="close" />
                </div>
              )}
              <Formik
                initialValues={{
                  ...initialValues,
                  bm_price: mockBillingInfo[isCheckedVs],
                }}
                validationSchema={!isChargeCard(credit_card_info) ? validationObject : ''}
                validate={(values) => {
                  return validate(values, 'bm');
                }}
                onSubmit={(values, { resetForm }) => handleBmPayment(values, resetForm)}
              >
                {(formikProp) => (
                  <HeadingWithIcon
                    sub_heading
                    name={
                      billing_due_vps_services == 1 ? 'account/billing_info.string43' : 'account/billing_info.string44'
                    }
                  >
                    <div id="Add_funds_vps" className="second-para">
                      {billing_vps_active == 0 && (
                        <P>
                          <Trans
                            i18nKey={'account/billing_info.string52'}
                            values={{
                              currency: userAccount.account_currency,
                              currency_symbol: userAccount.account_currency_symbol,
                              vps_active: billing_vps_active,
                              price: billing_vps_monthly_cost,
                            }}
                            components={{
                              font_bold: <span style={{ fontWeight: 'bold' }} />,
                              uppercase: <UpperCaseWord />,
                            }}
                          />
                        </P>
                      )}
                      {billing_due_vps_services == 1 && (
                        <P className="red">
                          {t(
                            billing_vps_how_many_due == 1
                              ? 'account/billing_info.string81'
                              : 'account/billing_info.string45',
                            { how_many_due: billing_vps_how_many_due },
                          )}
                        </P>
                      )}
                      {billing_due_vps_services != 1 && (
                        <P>{t('account/billing_info.string86', { how_many_due: billing_vps_active })}</P>
                      )}
                    </div>
                    {Number(billing_vps_active) > 0 && (
                      <>
                        <div style={{ margin: '0 0 2em -1.5rem' }}>
                          {billing_due_vps_services == 1 && (
                            <div className="d-flex">
                              <Styles.Prices onClick={() => setIsCheckedVs('billing_vps_how_much_due')}>
                                <Checkbox
                                  checkbox={isCheckedVs}
                                  setCheckedValue={() => setIsCheckedVs('billing_vps_how_much_due')}
                                  data={{ id: 'billing_vps_how_much_due' }}
                                />
                                <H6>
                                  <Trans
                                    i18nKey={'account/billing_info.string47'}
                                    values={{
                                      currency: userAccount.account_currency,
                                      currency_symbol: userAccount.account_currency_symbol,
                                      price: billing_vps_how_much_due,
                                    }}
                                    components={{ uppercase: <UpperCaseWord /> }}
                                  />
                                </H6>
                              </Styles.Prices>
                            </div>
                          )}
                          {billing_due_vps_services != 1 && (
                            <>
                              <div className="d-flex">
                                <Styles.Prices onClick={() => setIsCheckedVs('billing_vps_monthly_cost')}>
                                  <Checkbox
                                    checkbox={isCheckedVs}
                                    setCheckedValue={() => setIsCheckedVs('billing_vps_monthly_cost')}
                                    data={{ id: 'billing_vps_monthly_cost' }}
                                  />
                                  <H6>
                                    <Trans
                                      i18nKey={'account/billing_info.string48'}
                                      values={{
                                        price: billing_vps_monthly_cost,
                                        currency: userAccount.account_currency,
                                        currency_symbol: userAccount.account_currency_symbol,
                                      }}
                                      components={{ uppercase: <UpperCaseWord /> }}
                                    />
                                  </H6>
                                </Styles.Prices>
                              </div>
                              <div className="d-flex">
                                <Styles.Prices onClick={() => setIsCheckedVs('billing_vps_yearly_cost')}>
                                  <Checkbox
                                    checkbox={isCheckedVs}
                                    setCheckedValue={() => setIsCheckedVs('billing_vps_yearly_cost')}
                                    data={{ id: 'billing_vps_yearly_cost' }}
                                  />
                                  <H6>
                                    <Trans
                                      i18nKey={'account/billing_info.string49'}
                                      values={{
                                        price: billing_vps_yearly_cost,
                                        currency: userAccount.account_currency,
                                        currency_symbol: userAccount.account_currency_symbol,
                                      }}
                                      components={{ uppercase: <UpperCaseWord /> }}
                                    />
                                  </H6>
                                </Styles.Prices>
                              </div>
                            </>
                          )}
                        </div>
                        {billing_due_vps_services != 1 && (
                          <Styles.LastPara>
                            <P>{t('account/billing_info.string50')}</P>
                            <P>
                              <Trans i18nKey={'account/billing_info.string51'}>
                                <span
                                  style={{ textDecoration: 'underline', cursor: 'pointer', color: '#007bff' }}
                                  onClick={() => setIsOpen(vsInstanceArr.length > 0 ? true : false)}
                                />
                              </Trans>
                            </P>
                          </Styles.LastPara>
                        )}
                        <SlidingPanels size={match ? 93 : 72} isOpen={isOpen} isClose={() => setIsOpen(!isOpen)}>
                          <SlidingPanelPaymentTerm
                            setIsClose={(e) => setIsOpen(e)}
                            isLoading={false}
                            vsInstanceArr={vsInstanceArr}
                          />
                        </SlidingPanels>

                        <VmPaymentForm
                          id="Add_funds_vps"
                          handlePaypalBilling={handlePayPalBilling}
                          handleOneTimeBilling={handleOneTimeBilling}
                          billingChargeProductLoad={false}
                          allButton
                          amount={formikProp.values?.bm_price || 0}
                          paraAddfunds
                          addFundsBmCheck
                          addFunds
                          formikProp={formikProp}
                          cardError={() => cardError(formikProp.errors, formikProp.values, 'bm', formikProp.touched)}
                          creditCardButtonLoading={false}
                          creditCardButtonDisabled={false}
                          isButton
                        />
                      </>
                    )}
                  </HeadingWithIcon>
                )}
              </Formik>
            </Styles.VsService>
          )}
          <Formik
            initialValues={{
              ...initialValues,
              bm_price: billing_due_bm_services === '1' ? billing_bm_how_much_due : billing_bm_monthly_cost,
            }}
            validationSchema={!isChargeCard(credit_card_info) ? validationObject : ''}
            validate={(values) => {
              return validate(values, 'bm');
            }}
            onSubmit={(values, { resetForm }) => handleBmPayment(values, resetForm)}
          >
            {(formikProp) => (
              <Styles.BareService id="Add_funds_bm">
                <HeadingWithIcon
                  name={
                    billing_due_bm_services == 1 ? 'account/billing_info.string23' : 'account/billing_info.string22'
                  }
                  font_red
                  sub_heading
                >
                  <Styles.Para>
                    {billing_due_bm_services == 1 ? (
                      <P>
                        <Trans
                          i18nKey={'account/billing_info.string24'}
                          components={{
                            font_bold: <span style={{ fontWeight: 'bold' }} />,
                            font_red: <span style={{ color: 'red' }} />,
                          }}
                          values={{
                            bm_count: mockBillingInfo?.billing_bm_how_many_due,
                            price: currencyFilter(
                              mockBillingInfo?.billing_bm_how_much_due,
                              mockBillingInfo?.account_currency,
                            ),
                          }}
                        />
                      </P>
                    ) : (
                      <ConditionalFragment condition={account_approved == 1}>
                        {Number(mockBillingInfo?.billing_bm_active) > 0 ? (
                          <P>
                            <Trans
                              i18nKey={'account/billing_info.string25'}
                              components={{
                                font_bold: <span style={{ fontWeight: 'bold' }} />,
                              }}
                              values={{
                                bm_count: mockBillingInfo?.billing_bm_active,
                                price: currencyFilter(
                                  mockBillingInfo?.billing_bm_monthly_cost,
                                  mockBillingInfo?.account_currency,
                                ),
                              }}
                            />
                          </P>
                        ) : (
                          <P>{t('account/billing_info.string39')}</P>
                        )}
                      </ConditionalFragment>
                    )}
                    <ConditionalFragment condition={account_approved == 1}>
                      {Number(mockBillingInfo?.billing_bm_active) == 0 && (
                        <P>
                          <Trans i18nKey={'account/billing_info.string26'}>
                            <a
                              rel="noreferrer"
                              target="_blank"
                              href="https://ServerPoint.com/en/bare-metal-dedicated-server/"
                            />
                          </Trans>
                        </P>
                      )}
                    </ConditionalFragment>
                    <ConditionalFragment condition={account_approved == 0}>
                      <P>
                        <Trans
                          i18nKey={'account/billing_info.string28'}
                          components={{
                            bm_link: <Link to={'/bm/instance/create'} />,
                          }}
                        />
                      </P>
                    </ConditionalFragment>
                    <br />
                    <ConditionalFragment
                      condition={
                        Number(mockBillingInfo?.billing_bm_how_much_due) > 0 ? true : rights.billingmakepmt !== 0
                      }
                    >
                      <div style={{ marginLeft: '-1.5rem' }}>
                        {mockBillingInfo?.billing_due_bm_services == 1 ? (
                          <Styles.Price
                            onClick={() => {
                              setIsChecked('bm_due_amount');
                              formikProp.setFieldValue('bm_price', mockBillingInfo?.billing_bm_how_much_due);
                            }}
                          >
                            <Checkbox
                              checkbox={isChecked}
                              setCheckedValue={() => {
                                setIsChecked('bm_due_amount');
                                formikProp.setFieldValue('bm_price', mockBillingInfo?.billing_bm_how_much_due);
                              }}
                              data={{
                                id: 'bm_due_amount',
                              }}
                            />
                            <H6>
                              <Trans
                                i18nKey={'account/billing_info.string18'}
                                values={{
                                  price: currencyFilter(
                                    mockBillingInfo?.billing_bm_how_much_due,
                                    mockBillingInfo?.account_currency,
                                  ),
                                }}
                              />
                            </H6>
                          </Styles.Price>
                        ) : (
                          <>
                            {Number(mockBillingInfo?.billing_bm_active) > 0 && (
                              <Styles.Price
                                onClick={() => {
                                  setIsChecked('bm_funds_monthly');
                                  formikProp.setFieldValue('bm_price', mockBillingInfo?.billing_bm_monthly_cost);
                                }}
                              >
                                <Checkbox
                                  checkbox={isChecked}
                                  setCheckedValue={() => {
                                    setIsChecked('bm_funds_monthly');
                                    formikProp.setFieldValue('bm_price', mockBillingInfo?.billing_bm_monthly_cost);
                                  }}
                                  data={{
                                    id: 'bm_funds_monthly',
                                  }}
                                />
                                <H6>
                                  <Trans
                                    i18nKey={'account/billing_info.string29'}
                                    values={{
                                      price: currencyFilter(
                                        mockBillingInfo?.billing_bm_monthly_cost,
                                        mockBillingInfo?.account_currency,
                                      ),
                                    }}
                                  />
                                </H6>
                              </Styles.Price>
                            )}
                          </>
                        )}
                      </div>
                      <br />
                      {Number(mockBillingInfo?.billing_bm_active) > 0 && (
                        <VmPaymentForm
                          amount={formikProp.values?.bm_price || 0}
                          paraAddfunds
                          addFundsBmCheck
                          addFunds
                          formikProp={formikProp}
                          cardError={() => cardError(formikProp.errors, formikProp.values, 'bm')}
                          creditCardButtonLoading={false}
                          creditCardButtonDisabled={false}
                          isButton
                        />
                      )}
                    </ConditionalFragment>
                  </Styles.Para>
                </HeadingWithIcon>
              </Styles.BareService>
            )}
          </Formik>
        </div>
      </HeadingWithIcon>
    </Styles.CloudSC>
  );
};
export default ServicesByServerpoint;
